firebird.controller('marqueeCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    '$stateParams',
    '$q',
    'logService',
    'helperService',
    'meetingService',
    'attendeeService',
    'analyticsWrapperService',
    'meetingAPIService',
    'socketService',
    'avDeviceService',
    'localizationService',
    function (
        $window,
        $rootScope,
        $scope,
        $stateParams,
        $q,
        logService,
        helperService,
        meetingService,
        attendeeService,
        analyticsWrapperService,
        meetingAPIService,
        socketService,
        avDeviceService,
        localizationService
    ) {
        var self = this;

        self.hasAudioAndVideoOption = hasAudioAndVideoOption;
        self.showAudioAndVideoOption = showAudioAndVideoOption;
        self.hasMicOrWebcam = hasMicOrWebcam;

        self.meetingTitle = '';
        self.hostDisplayName = '';
        self.meetingCode = 0;

        //Title Editing
        self.isEditingTitle = false;
        self.isSavingTitle = false;
        self.editTitleInputValue = '';
        self.initialTitle = '';
        self.editTitle = editTitle;
        self.validateAndSaveTitle = validateAndSaveTitle;
        self.cancelEditTitle = cancelEditTitle;
        self.showEditError = showEditError;
        self.validateTitle = validateTitle;
        self.updateTitle = updateTitle;
        self.sanitizeTitle = sanitizeTitle;
        self.getCancelEditTitleBtnTooltip = getCancelEditTitleBtnTooltip;
        self.shouldShowMarqueeInvitationFeature = shouldShowMarqueeInvitationFeature;
        self.shouldShowEditButton = shouldShowEditButton;

        self.copyMeetingInvitation = copyMeetingInvitation;
        self.emailMeetingInvitation = emailMeetingInvitation;

        self.isRedesignEnabled = meetingService.getEnableMarqueeButtonHide();
        self.showMarqueeControls = attendeeService.getIsHost();
        self.onShowingTopBottomControls = onShowingTopBottomControls;
        self.isButtonFlexGrow = isButtonFlexGrow;

        $scope.$on('update-local-meeting-title', onUpdateLocalMeetingTitle);
        $scope.$on('content-initiating', onContentInitiating);
        $scope.$on('video-feed-count', onVideoFeedCountChange);
        $scope.$on('voting-started', onStartVoting);
        $scope.$on('start-qa-mode', onStartQandA);
        $scope.$on('showing-top-bottom-controls', self.onShowingTopBottomControls);

        init();

        ////////////////////////

        function copyMeetingInvitation() {
            analyticsWrapperService.eventTrack('Meeting - Marquee - Copied meeting information');
            $rootScope.$broadcast('copy-invitation-text');
        }

        function emailMeetingInvitation() {
            analyticsWrapperService.eventTrack('Meeting - Marquee - Clicked on Email meeting information');
            $rootScope.$broadcast('mail-invitation');
        }

        function init() {
            var meetingObj = meetingService.getCurrentMeeting();

            self.url =
                helperService.getLocationProtocol() +
                '://' +
                helperService.getLocationHost() +
                '/' +
                meetingObj.meetingCode;

            self.meetingTitle = meetingObj.title;
            self.hostDisplayName = meetingObj.hostDisplayName;
            self.meetingCode = meetingObj.meetingCode;
            self.editTitleInputValue = meetingObj.title;
        }

        function shouldShowMarqueeInvitationFeature() {
            return attendeeService.getIsHost() && !helperService.isVideoRoomApplication();
        }

        function shouldShowEditButton() {
            return !helperService.isVideoRoomApplication();
        }

        function hasAudioAndVideoOption() {
            if (!helperService.browserHasWebRTC() || !self.hasMicOrWebcam()) {
                return false;
            }

            if (!meetingService.isWebinar()) {
                return true;
            }

            return !attendeeService.getIsAttendee();
        }

        function showAudioAndVideoOption() {
            if (helperService.getIsRedesign()) {
                $rootScope.$broadcast('show-modal', 'meetingSettings');
            } else {
                $rootScope.$broadcast('show-modal', 'micWebcamOptions');
            }
        }

        function hasMicOrWebcam() {
            return avDeviceService.hasMicrophone() || avDeviceService.hasCamera();
        }

        function editTitle() {
            logService.log('Editing meeting title');
            analyticsWrapperService.eventTrack('Meeting - Marquee - Editing meeting title');

            self.initialTitle = self.editTitleInputValue;
            self.isEditingTitle = true;
            self.showMarqueeControls = true;
            digest();
        }

        function validateAndSaveTitle() {
            var newTitle = self.editTitleInputValue;

            //Nothing changed, close editor
            if (newTitle === self.meetingTitle) {
                self.isEditingTitle = false;
                self.showMarqueeControls = true;
                digest();
                return;
            }

            self.validateTitle(newTitle)
                .then(function () {
                    self.updateTitle(newTitle);
                })
                .catch(function (editError) {
                    self.showEditError(editError);
                });
        }

        function updateTitle(newTitle) {
            logService.log("Setting new meeting title to: '" + newTitle + "'");
            analyticsWrapperService.eventTrack('Meeting - Marquee - Meeting title update attempt');

            //When this is true, user is unable to change value
            //of title, nor close the editor
            self.isSavingTitle = true;
            digest();

            var params = {
                meetingCode: self.meetingCode,
                title: newTitle
            };

            meetingAPIService
                .setNewMeetingTitle(params)
                .then(function () {
                    logService.log("Meeting title changed from '" + self.initialTitle + "' to '" + newTitle + "'");
                    analyticsWrapperService.eventTrack('Meeting - Marquee - Meeting title update successful');

                    //Send updated title to Node Server,
                    //which will then propagate change to rest of clients
                    socketService.send({
                        message: 'meeting-title-updated',
                        data: { newMeetingTitle: newTitle }
                    });

                    self.editTitleInputValue = newTitle;
                    self.isEditingTitle = false;
                    digest();
                })
                .catch(function (err) {
                    logService.log('Unable to update meeting title:', err);
                    analyticsWrapperService.eventTrack('Meeting - Marquee - Meeting title update failed');

                    //The err here is meant for debugging purposes,
                    //but we don't necessarily want to show that message to front-end users
                    self.showEditError(localizationService.translate('MARQUEE.DIALOG.UPDATE_TITLE_ERROR'));
                })
                .finally(function () {
                    self.isSavingTitle = false;
                    digest();
                });
        }

        function sanitizeTitle(title) {
            var newTitle = '';

            try {
                //Strips string of any html tags
                newTitle = $('<div/>').html(title).text();
            } catch (e) {
                newTitle = title;
            }

            return newTitle;
        }

        function cancelEditTitle() {
            if (self.isSavingTitle) {
                return;
            }

            logService.log('Cancelling edit meeting title');
            analyticsWrapperService.eventTrack('Meeting - Marquee - Cancelling edit meeting title');

            self.isEditingTitle = false;
            self.editTitleInputValue = self.initialTitle;
            digest();
        }

        function showEditError(message) {
            var errMsg = message ? message : localizationService.translate('MARQUEE.DIALOG.UPDATE_TITLE_PROBLEM');

            if (helperService.getIsRedesign() === true) {
                var closeButtonHtml =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                $window.swal({
                    title: closeButtonHtml + errMsg,
                    confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-error.svg'
                });
            } else {
                //TODO: REMOVE POST-REDESIGN
                $window.swal({
                    title: errMsg,
                    type: 'error',
                    confirmButtonText: 'Okay'
                });
            }
        }

        function onUpdateLocalMeetingTitle() {
            var newTitle = meetingService.getTitle();

            if (self.meetingTitle !== newTitle) {
                self.meetingTitle = newTitle;
                self.editTitleInputValue = newTitle;
                digest();
            }
        }

        function validateTitle(newTitle) {
            var deferred = $q.defer();

            if (newTitle) {
                //Shouldn't be possible since input has max-length
                //but checking here just in case
                if (newTitle.length > 100) {
                    deferred.reject(localizationService.translate('MARQUEE.VALIDATION.TITLE_TOO_LONG'));
                } else {
                    deferred.resolve();
                }
            } else {
                deferred.reject(localizationService.translate('MARQUEE.VALIDATION.TITLE_TOO_SHORT'));
            }

            return deferred.promise;
        }

        function getCancelEditTitleBtnTooltip() {
            var titleKey = self.isSavingTitle ? 'MARQUEE.CANCEL_TITLE.UPDATING' : 'MARQUEE.CANCEL_TITLE.CANCEL';
            return localizationService.translate(titleKey);
        }

        function onContentInitiating() {
            if (self.isEditingTitle) {
                self.cancelEditTitle();
            }
        }

        function onVideoFeedCountChange(e, count) {
            if (count >= 1 && self.isEditingTitle) {
                self.cancelEditTitle();
            }
        }

        function onStartVoting() {
            if (self.isEditingTitle) {
                self.cancelEditTitle();
            }
        }

        function onStartQandA() {
            if (self.isEditingTitle) {
                self.cancelEditTitle();
            }
        }

        function onShowingTopBottomControls(e, data) {
            if (attendeeService.getIsHost() && !self.isEditingTitle) {
                self.showMarqueeControls = data;
            }
        }

        function isButtonFlexGrow() {
            if (['ru-RU', 'de-DE', 'fr-CA', 'es-419', 'nl-NL'].includes(localizationService.getLocalization())) {
                return true;
            }
            return false;
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
